// extracted by mini-css-extract-plugin
export default {"emptyMod":"emptyMod--vtG0E","icon":"icon--y1xnw","text":"text--Rg3VY"};